<ng-content></ng-content>
<div class="__card-header-background" *ngIf="dropShadow"></div>
<div class="__card-header-shadow" *ngIf="dropShadow"></div>
